<template>
    <div class="data-container">
        <el-tabs class="elTabs" v-model="tab_active" @tab-change="tabChange">
            <el-tab-pane label="温采设备监测" name="1"></el-tab-pane>
            <el-tab-pane label="管道传感器监测" name="2"></el-tab-pane>
        </el-tabs>
        <div class="export-container"></div>
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            <el-button :icon="Upload" @click="exportData" v-permission="['factory:monitors:batch-export']">
                最新数据导出
            </el-button>
            <div class="total-box">
                <span>查询时间：{{ dateTime }}</span>
                <span>成功查询设备数：{{ total }}台</span>
            </div>
        </div>
        <el-form :inline="true" label-width="60">
            <el-form-item v-for="(item, index) in imei_list" :key="'imei' + index" :label="'设备' + (index + 1)">
                <div class="imei-box">
                    <el-input v-model="item.imei" placeholder="请输入IMEI" clearable class="input" style="width: 260px">
                        <template #append>
                            <el-button type="danger" :icon="Delete" plain @click="removeSearchItem(index)">删除</el-button>
                        </template>
                    </el-input>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :icon="Plus" plain @click="addSearchItem">增加搜索项</el-button>
                <el-button type="primary" :icon="Download" plain @click="uploadVisible = true">导入IMEI</el-button>
                <el-button type="primary" :icon="Search" @click="handleSearch">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="table_data" v-loading="tableLoading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column label="IMEI" min-width="100" prop="IMEI"></el-table-column>
            <el-table-column label="版本号" min-width="100" prop="version"></el-table-column>
            <el-table-column label="ICCID" min-width="150" prop="ICCID"></el-table-column>
            <el-table-column label="固件生成日期" min-width="150" prop="firmware_date"></el-table-column>
            <el-table-column label="最近注册日期" min-width="150" prop="reg_ts"></el-table-column>
            <el-table-column label="操作" width="160px" fixed="right">
                <template #default="{ row }">
                    <el-link
                        type="primary"
                        :underline="false"
                        @click="viewRecord(row)"
                        v-permission="['factory:monitors:record']"
                    >
                        历史数据
                    </el-link>
                </template>
            </el-table-column>
        </el-table>
        <record-dialog v-model="show_record_dialog" :deviceData="device_data" />
        <el-pagination
            v-if="total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination_data.page"
            :page-size="pagination_data.page_size"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        />
        <imports-form
            v-if="uploadVisible"
            v-model="uploadVisible"
            @updateForm="importSearch"
            menuCode="heating/device"
            :params-data="{ type: tab_active }"
        />
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { Delete, Download, Plus, Refresh, Search, Upload } from '@element-plus/icons'
import { getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import RecordDialog from './components/RecordDialog.vue'
import ImportsForm from './components/ImportsForm.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { getDevicesRecord } from '@/api/heating/monitoring.js'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'

// 标签页
const tab_active = ref('1')
function tabChange(tab) {
    tab_active.value = tab
    imei_list.value = [
        {
            imei: ''
        }
    ]
}

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        const room_locations = {}

        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }

        getRoom(data[0]?.children ?? [], '')
        room_list.value = room_locations
    })
}

// 搜索IMEI
const imei_list = ref([
    {
        imei: ''
    }
])
function addSearchItem() {
    imei_list.value.push({
        imei: ''
    })
}
function removeSearchItem(index) {
    if (index === 0) {
        ElMessage.warning('请至少保留一个IMEI')
    } else {
        imei_list.value.splice(index, 1)
    }
}

// 导入
const uploadVisible = ref(false)
function importSearch(arr) {
    imei_list.value = []
    arr.forEach((item) => {
        imei_list.value.push({
            imei: item
        })
    })
    uploadVisible.value = false
}

// 搜索回到第一页
const handleSearch = () => {
    pagination_data.page = 1

    getTableData(imei_list.value.filter((item) => item.imei !== '').map((item) => item.imei))
}

// 重置
const resetQueryForm = () => {
    imei_list.value = [
        {
            imei: ''
        }
    ]
    pagination_data.page = 1
    table_data.value = []
}

// 格式化对象
const getNowDate = () => {
    const date = new Date()
    const sign2 = ':'
    const year = date.getFullYear() // 年
    let month = date.getMonth() + 1 // 月
    let day = date.getDate() // 日
    let hour = date.getHours() // 时
    let minutes = date.getMinutes() // 分
    let seconds = date.getSeconds() // 秒
    if (month >= 1 && month <= 9) {
        month = '0' + month
    }
    if (day >= 0 && day <= 9) {
        day = '0' + day
    }
    if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds
    }
    return year + '-' + month + '-' + day + ' ' + hour + sign2 + minutes + sign2 + seconds
}

// 刷新时间
const dateTime = ref('')
function refreshTime() {
    dateTime.value = getNowDate()
}

// 分页相关
const pagination_data = reactive({
    page: 1,
    page_size: 20
})
const total = ref(0)
const handleSizeChange = (currentSize) => {
    pagination_data.page_size = currentSize
    pagination_data.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    pagination_data.page = currentPage
    getTableData()
}
const table_data = ref([])
const tableLoading = ref(false)
async function getTableData(imeis = []) {
    tableLoading.value = true
    const params = pagination_data
    // const params = {}
    params.type = tab_active.value
    params.IMEIS = imeis.join(',')
    const result = await getDeviceList(params)
    table_data.value = result.lists
    total.value = result.total
    refreshTime()
    tableLoading.value = false
}

// 表格多选
const selected_list = ref([])
function handleSelectionChange(list) {
    selected_list.value = list.map((item) => {
        return item.id
    })
}

// 最新数据导出
function exportData() {
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = []
            await getDevicesRecord({
                type: 1,
                devices: selected_list.value
            }).then((data) => {
                list = data
            })
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }

            // 创建excel并写入数据
            let workbook = null
            workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            workbook.lastPrinted = new Date()
            const worksheet = workbook.addWorksheet('设备数据', {
                properties: {
                    defaultRowHeight: 22
                },
                pageSetup: {
                    horizontalCentered: true
                }
            })

            worksheet.columns = [
                {
                    header: '序号',
                    key: 'index',
                    width: 10
                },
                {
                    header: '安装地址',
                    key: 'address',
                    width: 50
                },
                {
                    header: '热力站名称',
                    key: 'station',
                    width: 30
                },
                {
                    header: '小区名称',
                    key: 'residential_name',
                    width: 20
                },
                {
                    header: '楼栋',
                    key: 'building',
                    width: 10
                },
                {
                    header: '单元',
                    key: 'unit',
                    width: 10
                },
                {
                    header: '楼层',
                    key: 'floor',
                    width: 10
                },
                {
                    header: '房间',
                    key: 'room',
                    width: 20
                },
                {
                    header: '户名',
                    key: 'name',
                    width: 20
                },
                {
                    header: '联系电话',
                    key: 'phone',
                    width: 30
                },
                {
                    header: '型号规格',
                    key: 'model',
                    width: 20
                },
                {
                    header: '设备编号（IMEI）',
                    key: 'IMEI',
                    width: 50
                },
                {
                    header: '上传时间',
                    key: 'ts',
                    width: 22
                },
                {
                    header: '采集时间',
                    key: 'data_ts',
                    width: 22
                },
                {
                    header: '室温（℃）',
                    key: 'roottemp',
                    width: 15
                },
                {
                    header: '湿度（%）',
                    key: 'humidity',
                    width: 15
                },
                {
                    header: '信号强度',
                    key: 'csq',
                    width: 15
                },
                {
                    header: '电池电量（%）',
                    key: 'bat',
                    width: 15
                },
                {
                    header: '告警标记',
                    key: 'alarm_flags',
                    width: 20
                },
                {
                    header: '补偿温度',
                    key: 'temperature_compensation',
                    width: 20
                },
                {
                    header: '上报周期',
                    key: 'upperi',
                    width: 20
                },
                {
                    header: '是否显示',
                    key: 'show_panel',
                    width: 20
                },
                {
                    header: '是否在线',
                    key: 'online',
                    width: 20
                },
                {
                    header: '版本号',
                    key: 'version',
                    width: 20
                },
                {
                    header: 'ICCID',
                    key: 'iccid',
                    width: 20
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        index: item.index,
                        address: item.address,
                        station: item.station,
                        residential_name: item.location[1],
                        building: item.location[2],
                        unit: item.location[3],
                        floor: item.location[4],
                        room: item.location[5],
                        name: item.name,
                        phone: item.phone,
                        model: model_list.value[item.model]
                            ? model_list.value[item.model].type + '/' + model_list.value[item.model].model
                            : '',
                        IMEI: item.IMEI,
                        ts: item.ts,
                        data_ts: item.data_ts,
                        roottemp: item.roottemp,
                        humidity: item.humidity <= 100 ? item.humidity : '',
                        csq: item.csq,
                        bat: item.bat,
                        alarm_flags:
                            ((item.flags & (1 << 7)) !== 0 ? '掉电故障' : '') +
                            ((item.flags & (1 << 7)) !== 0 && (item.flags & (1 << 6)) !== 0 ? '，' : '') +
                            ((item.flags & (1 << 6)) !== 0 ? '移位故障' : ''),
                        temperature_compensation: item.temperature_compensation,
                        upperi: item.upperi,
                        show_panel: item.show_panel ? '显示' : '不显示',
                        online: item.online ? '在线' : '离线',
                        version: item.version,
                        iccid: item.iccid
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            // 导出excel文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const year = date.getFullYear() // 年
                let month = date.getMonth() + 1 // 月
                let day = date.getDate() // 日
                let hour = date.getHours() // 时
                let minutes = date.getMinutes() // 分
                let seconds = date.getSeconds() // 秒
                // 给一位数的数据前面加 “0”
                if (month >= 1 && month <= 9) month = '0' + month
                if (day >= 0 && day <= 9) day = '0' + day
                if (hour >= 0 && hour <= 9) hour = '0' + hour
                if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
                if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
                const presentDate = `设备最新监测数据${year}${month}${day}${hour}${minutes}${seconds}`

                // 导出并存储文件
                FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
            })
            loading.close()
        })
        .catch(() => {})
}

// 选中的设备id
const device_data = ref({}) // 点中的模块id

// 查看历史采集数据
const show_record_dialog = ref(false)
function viewRecord(row) {
    device_data.value = { ...row, type: tab_active.value }
    show_record_dialog.value = true
}

onMounted(async () => {
    await getModelList()
    await getRoomTree()
    // await getTableData()
})
</script>

<style lang="scss" scoped>
.total-box {
    font-size: 14px;
    color: #606266;
    line-height: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.total-box span {
    margin-left: 30px;
}
</style>
